import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import {
  getRequiredFields,
  removeEmptyFields,
  setEmptyFieldsToNull,
  toYMD,
} from "@/lib/utils";
import {
  YEAR,
  PDC_NO,
  PDC_AMOUNT,
  PDC_DATE,
  PDC_REMARKS,
  PDC_CHECK,
} from "./consts";
import { useIsMobile } from "@/hooks/use-mobile";
import { formValues, schema } from "./validations";

interface UseUpdatePdcProps {
  onCancel: () => void;
  installmentIndex: number | null;
  form: any;
  INSTALLMENT: string;
}

const useUpdatePdc = ({
  onCancel,
  installmentIndex,
  form: parentForm,
  INSTALLMENT,
}: UseUpdatePdcProps) => {
  const isMobile = useIsMobile();

  const form = useForm<formValues>({
    resolver: zodResolver(schema),
    defaultValues: {
      [YEAR]: "",
      [PDC_NO]: "",
      [PDC_AMOUNT]: "",
      [PDC_DATE]: "",
      [PDC_REMARKS]: "",
      [PDC_CHECK]: true,
    },
  });

  const requiredFields = getRequiredFields(schema);

  const onSubmit = (data: formValues) => {
    // Save PDC data to the parent form
    if (installmentIndex !== null && parentForm && INSTALLMENT) {
      const currentInstallments = parentForm.getValues(INSTALLMENT) || [];
      const currentInstallment = currentInstallments[installmentIndex] || {};
      const existingPdcData = currentInstallment.pdcData || [];

      const newPdcData = {
        year: Number(data[YEAR] || 0),
        pdcNumber: Number(data[PDC_NO] || 0),
        pdcDate: toYMD(data[PDC_DATE]) || "",
        pdcAmount: Number(data[PDC_AMOUNT] || 0),
        pdcRemarks: data[PDC_REMARKS] || null,
        pdcCheck: data[PDC_CHECK] || false,
      };

      // Add new PDC data to the installment
      const updatedPdcData = [...existingPdcData, newPdcData];
      const updatedInstallment = {
        ...currentInstallment,
        pdcData: updatedPdcData,
      };

      const updatedInstallments = [...currentInstallments];
      updatedInstallments[installmentIndex] = updatedInstallment;
      parentForm.setValue(INSTALLMENT, updatedInstallments);
    }

    onCancel();
  };

  return {
    form,
    onSubmit,
    requiredFields,
    isMobile,
  };
};

export default useUpdatePdc;
